<template>
  <v-container grid-list-md>

    <v-layout row wrap>
      <v-flex xs12 sm6>
        <v-text-field name="nome" required v-model="usuario.nome" label="Nome"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-text-field name="email" required v-model="usuario.email" label="E-mail"></v-text-field>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field name="username" required v-model="usuario.username" label="Login"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="password"         
        v-model="usuario.password" 
        label="Senha"
        :append-icon="mostrarSenha ? 'visibility' : 'visibility_off'"
        :append-icon-cb="() => (mostrarSenha = !mostrarSenha)"
        :type="mostrarSenha ? 'password' : 'text'"></v-text-field>
      </v-flex>

      <v-flex xs12 sm4>
        <v-select
          required
          chips
          label="Permissões"
          v-bind:items="itemsPermissoes"
          v-model="usuario.authorities"
          item-text="authority"
          item-value="id"
          multiple
          max-height="400"
          hint="Selecione as permissões"
          persistent-hint
        ></v-select>  
      </v-flex>
     
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-text-field name="cpf" v-model="usuario.cpf" label="CPF"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="crm" v-model="usuario.crm" label="CRM"></v-text-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field name="crmUf" v-model="usuario.crmUf" label="UF CRM"></v-text-field>
      </v-flex>
    </v-layout>


    <v-layout row wrap>
      <v-flex xs12 sm2>
        <v-switch label="Ativo" color="primary" v-model="usuario.enabled"></v-switch>
      </v-flex>
      <v-flex xs12 sm2>
        <v-switch label="Bloqueado" color="primary" v-model="usuario.accountLocked"></v-switch>
      </v-flex>
      <v-flex xs12 sm2>
        <v-switch label="Conta Expirada" color="primary" v-model="usuario.accountExpired"></v-switch>
      </v-flex>
      <v-flex xs12 sm2>
        <v-switch label="Senha Expirada" color="primary" v-model="usuario.passwordExpired"></v-switch>
      </v-flex>

    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-select
          chips
          label="Empresas"
          v-bind:items="empresas"
          v-model="usuario.empresas"
          item-text="nome"
          item-value="id"
          multiple
          max-height="400"
          hint="Selecione as empresas"
          persistent-hint
        ></v-select>  
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-select
          chips
          label="Unidades"
          v-bind:items="unidades"
          v-model="usuario.unidades"
          item-text="nome"
          item-value="id"
          multiple
          max-height="400"
          hint="Selecione as unidades"
          persistent-hint
        ></v-select>
      </v-flex>
    </v-layout>

      <v-snackbar
        :timeout="timeoutAlerta"
        :color="tipoAlerta"
        v-model="snackbar">
        {{ textAlerta }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>
    
  </v-container>

</template>

<script>
import axios from 'axios'

export default {
  name: 'usuario-form',
  props: {
    usuario: {}
  },
  data () {
    return {
      mostrarSenha: true,
      itemsPermissoes: [],
      empresas: [],
      unidades: [],
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    }
  },
  components: {
  },
  methods: {
    pupularPermissoes () {
      var self = this
      axios.get('/permissoes')
      .then(response => {
        self.itemsPermissoes = response.data.list
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao carregar permissões'
        self.snackbar = true
      })
    },
    pupularEmpresas () {
      var self = this
      axios.get('/empresas')
      .then(response => {
        self.empresas = response.data.list
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao carregar empresas'
        self.snackbar = true
      })
    },
    pupularUnidades () {
      var self = this
      axios.get('/unidades')
      .then(response => {
        self.unidades = response.data.list
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao carregar unidades'
        self.snackbar = true
      })
    }
  },
  created () {
    this.pupularPermissoes()
    this.pupularEmpresas()
    this.pupularUnidades()
  }
}
</script>

<style scoped>

  input[type=file] {
      position: absolute;
      left: -99999px;
  }
</style>



// WEBPACK FOOTER //
// UsuarioForm.vue?350c62e4